import LiquidityHeatmap from './LiquidityHeatmap';

function App() {
  return <LiquidityHeatmap />;
}

export default App;